import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PATH } from '@app/constants';

import { ProjectInfoComponent } from './project-info/project-info.component';
import { ProjectMarketComponent } from './project-market/project-market.component';
import { ProjectPurchaseComponent } from './project-purchase/project-purchase.component';
import { ProjectInfoV2Component } from './project-info-v2/project-info-v2.component';

const routes: Routes = [
  { path: `${PATH.PROJECTS_MARKET}/:view`, component: ProjectMarketComponent },
  { path: PATH.PROJECTS_PURCHASE, component: ProjectPurchaseComponent },
  { path: `${PATH.PROJECTS_V2}/:pid`, component: ProjectInfoV2Component }, 
  { path: ':pid', component: ProjectInfoComponent },
  { path: ':pid/invertir', component: ProjectPurchaseComponent },
  { path: '**', redirectTo: PATH.PROJECTS_MARKET, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectsRoutingModule { }
